import { fakeLocations } from "../data/fake-locations";

export function getGeolocation(): Promise<{
  longitude: number;
  latitude: number;
  accuracy: number;
}> {
  const fakeLocationKey = import.meta.env.VITE_FAKE_LOCATION;

  if (fakeLocationKey) {
    const fakeLocation = fakeLocations.find(
      (loc) => loc.key === fakeLocationKey
    );
    if (fakeLocation) {
      return Promise.resolve({
        longitude: fakeLocation.long,
        latitude: fakeLocation.lat,
        accuracy: fakeLocation.accuracy ?? 0,
      });
    }
  }

  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          longitude: position.coords.longitude,
          latitude: position.coords.latitude,
          accuracy: position.coords.accuracy,
        });
      },
      (error) => {
        reject(error);
      }
    );
  });
}
